export enum AssessmentFlags {
  VisaStudyInAustralia = 1 << 0,
  VisaWorkInAustralia = 1 << 1,
  VisaSkilledMigrant = 1 << 2,
  VisaJoinSpouse = 1 << 3,
  VisaJoinParents = 1 << 4,
  VisaJoinChild = 1 << 5,
  VisaVisitAustralia = 1 << 6,
  VisaOwnABusiness = 1 << 7,
  VisaNotSure = 1 << 8,
  SponsorChild = 1 << 9,
  SponsorPartner = 1 << 10,
  SponsorParent = 1 << 11,
  SponsorFamilyNotSure = 1 << 12,
  SponsorEmployeeTempWork = 1 << 13,
  SponsorEmployeePermanentResidence = 1 << 14,
  SponsorEmployeeNotSure = 1 << 15,
  AppealRefused = 1 << 16,
  AppealCancelled = 1 << 17,
  VerifyVisaDirectEmployee = 1 << 18,
  VerifyVisaContractedWorker = 1 << 19,
  VerifyVisaMyself = 1 << 20,
  Unknown = 0
}

export const AssessmentFlagLabels: Record<AssessmentFlags, string> = {
  [AssessmentFlags.VisaStudyInAustralia]: "Study in Australia",
  [AssessmentFlags.VisaWorkInAustralia]: "Work in Australia",
  [AssessmentFlags.VisaSkilledMigrant]: "Live and Work as a Skilled Migrant",
  [AssessmentFlags.VisaJoinSpouse]: "Join my Spouse/Partner",
  [AssessmentFlags.VisaJoinParents]: "Join my Parents",
  [AssessmentFlags.VisaJoinChild]: "Join my Child",
  [AssessmentFlags.VisaVisitAustralia]: "Visit Australia",
  [AssessmentFlags.VisaOwnABusiness]: "Own a Business",
  [AssessmentFlags.VisaNotSure]: "I'm not Sure",
  [AssessmentFlags.SponsorChild]: "A Child Visa",
  [AssessmentFlags.SponsorPartner]: "A Partner/Spouse Visa",
  [AssessmentFlags.SponsorParent]: "A Parent Visa",
  [AssessmentFlags.SponsorFamilyNotSure]: "I'm not Sure",
  [AssessmentFlags.SponsorEmployeeTempWork]: "A Temporary Work Visa",
  [AssessmentFlags.SponsorEmployeePermanentResidence]: "A Permanent Residence Visa",
  [AssessmentFlags.SponsorEmployeeNotSure]: "I'm not Sure",
  [AssessmentFlags.AppealRefused]: "A Visa Refusal",
  [AssessmentFlags.AppealCancelled]: "A Cancelled Visa",
  [AssessmentFlags.VerifyVisaDirectEmployee]: "A Direct Employee",
  [AssessmentFlags.VerifyVisaContractedWorker]: "A Contracted Worker",
  [AssessmentFlags.VerifyVisaMyself]: "Myself",
  [AssessmentFlags.Unknown]: "Unknown"
};